import React from 'react';
export function TopBar() {
  return <div className="bg-gradient-gold-rose py-3 px-5 text-center font-bold text-negro tracking-[1px] animate-pulse-bar text-[10px]" data-id="element-173">
      ⚡ OFERTA DE LANZAMIENTO —{' '}
      <span className="line-through opacity-70 mr-2" data-id="element-174">
        Valor Real: $72.000 ARS
      </span>{' '}
      → HOY SOLO: $19.999 ARS ⚡
    </div>;
}